
 <div class="v-flex " v-if="item.type === 2" >
     <p-dms-rename
         v-model   = "openRename"
         :filename = "item.name"
         @save     = "onSave"
     />

     <!--
    <v-menu
        v-model     = "showMenu"
        :position-x = "x"
        :position-y = "y"
        absolute
        offset-y
    >
        <v-list>
            <v-list-item link @click="onEdit">
                <v-list-item-title>Umbenennen</v-list-item-title>
            </v-list-item>
            <v-list-item link @click="onSync">
                <v-list-item-title>synchronisieren</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
    -->

    <a
        :class       = "!item.dmsId ? 'secondary--text' : 'primary--text'"
        @click       = "onDocument(item)"
        @contextmenu = "onContextMenu"
    >
        <p-dms-treeview-entry
            :entry = "item"
        >
            <template v-slot:icon>
                <div style = "width: 25px;">
                    <v-icon
                        size  = "21"
                        color = "primary"
                    >
                        {{ icon (item) }}
                    </v-icon>
                </div>

            </template>
        </p-dms-treeview-entry>
    </a>
</div>
